<template>
	<div class="home">
		<Header ref="header" :type='headType'></Header>
		<BanIn url="image003">
			<template v-slot:text>
				<h2 class="inTit f48 wow fadeInLeft">经典案例</h2>
				<div class="inDes f24 wow fadeInRight">
					<p>提供仓储、装卸、简单包装、配送、库存管理、信息处理、咨询等“一站式”综合物流服务</p>
				</div>
			</template>
		</BanIn>
        <div class="mainBg">
			<div class="caseBg">
				<div class="wrap">
                    <div class="hmTit text-center wow fadeInDown">
                        <h2 class="hmTitCn f40 color0">经典案例</h2>
                    </div>
                    <ul class="sortList wow fadeInUp">
                        <li :class="{active:type ==''}"><router-link to="/case">全部</router-link></li>
						<li v-for="(item, index) in caseType" :key="index" :class="type == item[0] ? 'active' : '' "><router-link :to="'/case?type='+ item[0]">{{ item[1] }}</router-link></li>
                    </ul>
					<ul class="caseList flex flex-wrap" v-if="caseList.length">
						<li v-for="(item, index) in caseList" :key="index">
							<router-link class="caseLink" :to="'/caseDetail?id=' + item.id">
								<div class="caseImg">
									<img :src="item.image" alt="">
								</div>
								<div class="caseLine"></div>
								<h3 class="caseTit f24 color3 ellipsis">{{item.title}}</h3>
								<div class="caseCon MultiLine">
									<div class="caseDes" v-html="item.content"></div>
								</div>
							</router-link>
						</li>
					</ul>
					<el-empty v-else description="暂无内容"></el-empty>
					<el-pagination
						:page-size="size"
						:pager-count="5"
						layout="prev, pager, next"
						:total="total"
						@current-change="getpage"
						v-if="caseList.length"
					>
					</el-pagination>
					<div class="brandBox">
						<div class="hmTit text-center wow fadeInDown">
							<h2 class="hmTitCn f40 color0">合作品牌</h2>
							<div class="hmTitDes f20 color6">
								<p>排名不分先后</p>
							</div>
						</div>
						<div class="brandList">
							<div class="swiper-container">
								<div class="swiper-wrapper">
									<div class="swiper-slide" v-for="(item, index) in brandList" :key="index">
										<div class="brandLink">
											<div class="brandImg flex-center">
												<img :src="item.image" :alt="item.full_name">
											</div>
										</div>
									</div>
								</div>
								<div class="hm-pagination"></div>
							</div>
						</div>
						
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import BanIn from '@/components/BanIn.vue'
	import Footer from '@/components/Footer.vue'
	import Swiper from 'swiper'  // ES引入方式
	import { WOW } from 'wowjs'
	import home from '../api/home'
	export default {
		name: 'Case',
		components: {
			Header,
			BanIn,
			Footer
		},
		data() {
			return {
				headType:3,
				type:'',
				caseType:[],
				page:1,
				size:9,
				caseList:[],
				total:0,
				brandList:[]
			}
		},
		watch: {
			'$route' () {
				this.type = this.$route.query.type || '';
				this.page = 1;
				this.size = 9;
				this.getlist();
			}
		},
		mounted() {
			this.$nextTick(()=>{
				new WOW({ boxClass:"wow",animateClass:"animated",offset:5,mobile:true,live:false,resetAnimation:true }).init()
				new Swiper('.brandList .swiper-container', {
					speed: 800,
					spaceBetween: 5,
					slidesPerView: 2,
					slidesPerColumn: 2,
					slidesPerGroup: 2,
					slidesPerColumnFill : 'row',
					watchOverflow: true,
					resistance: true,
					resistanceRatio: 0,
					observer: true,
					observeParents: true,
					centerInsufficientSlides: true,
					watchSlidesVisibility: true,
					pagination: {
						el: '.brandList .hm-pagination',
						clickable: true
					},
					breakpoints: {
						1600: {
							slidesPerView: 5,
							slidesPerColumn: 2,
							spaceBetween: 30,
							slidesPerGroup: 5,
						},
						1200: {
							slidesPerView: 5,
							spaceBetween: 20,
							slidesPerColumn: 2,
							slidesPerGroup: 5,
						},
						991: {
							slidesPerView: 3,
							spaceBetween: 15,
							slidesPerColumn: 2,
							slidesPerGroup: 3,
						},
						767: {
							slidesPerView: 2,
							spaceBetween: 10,
							slidesPerColumn: 2,
							slidesPerGroup: 2,
						},
						460: {
							slidesPerView: 2,
							spaceBetween: 5,
							slidesPerColumn: 2,
							slidesPerGroup: 2,
						}
					}
				})
				// // 动态内容加载完成后调用 sync 方法，确保在每次动态加载内容后调用 this.$wow.sync() 方法，以便 WOW.js 能够重新扫描页面并为新的 wow 元素添加动画（没起作用）
				// this.$nextTick(() => {
				//   this.$wow.sync();
				// });
			});

			this.type = this.$route.query.type || '';
			this.getlist();
			this.getCooperate();
		},
		methods:{
			getlist(){
				home.caseList({page:this.page,limit:this.size,t:this.type}).then((res)=>{
					if (res.code === 1) {
						this.caseType = Object.entries(res.data.company);
						this.caseList = res.data.rows;
						this.total = res.data.total;
						// console.log(this.caseType)
					} else {
						this.$toast(res.msg)
					}
				});
			},
			getpage(e){
				window.scrollTo(0,0);
				this.page = e;
				this.getlist();
			},
			getCooperate(){
				home.cooperate().then((res)=>{
					if(res.code === 1) {
						this.brandList = res.data.rows
					} else {
						this.$toast(res.msg)
					}
				});
			}
		}
		
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/case.scss';
</style>